import React, { useEffect, useState } from "react";
import api from "../../../../Services/Api/api";
import { Button } from "react-bootstrap";

const INR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

const UserBalanceSnapshot = ({
  userId,
  title = "Total Balances on this Transaction",
  compact = false,
}) => {
  const [balanceDue, setBalanceDue] = useState(null);
  const [commissionBal, setCommissionBal] = useState(null);
  const [snapshotAt, setSnapshotAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);

    try {
      const { transactions } = await api.get("v1/office/transaction", {
        queryStr: JSON.stringify({
          limit: 1,
          order: -1,
          sortby: "date",
          where: { relatedUser: userId },
        }),
      });

      const lastTr = transactions?.[0];
      if (!lastTr) return;

      setBalanceDue(Number(lastTr.userBalanceDue?.total || 0));
      setCommissionBal(Number(lastTr.commissionBalance?.total || 0));
      setSnapshotAt(lastTr.date || null);
    } catch (e) {
      setError("Failed to load user balances");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) return;

    load();
  }, [userId]);

  return (
    <div className="border rounded p-2 bg-light">
      <div className="fw-semibold small mb-1">{title}</div>

      {loading ? (
        <div className="small text-muted">Loading balances…</div>
      ) : error ? (
        <div className="small text-danger">{error}</div>
      ) : (
        <>
          <div style={{ float: "right" }}>
            <Button
              size="xs"
              variant="outline-secondary"
              style={{ fontSize: "10px", padding: "2px" }}
              onClick={load}
            >
              Refresh
            </Button>
          </div>
          <div className="small">
            <strong>Total Balance Due:</strong> {INR(balanceDue)}
          </div>

          <div className="small">
            <strong>Total Commission Balance:</strong> {INR(commissionBal)}
          </div>

          {snapshotAt && (
            <div className="small text-muted">
              Snapshot: {new Date(snapshotAt).toLocaleString()}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserBalanceSnapshot;
